import * as React from 'react';
import { IconProps } from '../types';

const IcFunctionVIP = (props: IconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    viewBox="0 0 24 24"
    fill="none"
    {...props}
  >
    <path
      fill={props?.fill ?? '#232F3E'}
      d="M11.456 3.519a1.158 1.158 0 0 1 1.887-.294c.301.314.402.805.244 1.212a1.194 1.194 0 0 1-.83.731c1.591 1.962 3.183 3.923 4.776 5.884 1.623-.815 3.243-1.636 4.864-2.453-.12-.19-.214-.403-.217-.631-.022-.405.186-.811.526-1.028a1.158 1.158 0 0 1 1.789.875c.037.384-.134.778-.436 1.016-.294.24-.708.313-1.068.194-1.18 2.998-2.347 6.002-3.523 9.002H5.533c-1.175-3-2.339-6.005-3.52-9.003a1.14 1.14 0 0 1-1.07-.192c-.332-.257-.5-.701-.426-1.115a1.17 1.17 0 0 1 1.043-.962c.457-.047.923.21 1.13.621.207.382.163.87-.086 1.222 1.62.845 3.245 1.681 4.864 2.527C9.063 9.14 10.652 7.153 12.25 5.17a1.215 1.215 0 0 1-.723-.51 1.173 1.173 0 0 1-.07-1.142ZM5.533 18.805H19.47c-.002.777 0 1.555-.001 2.332-4.645.002-9.29 0-13.936.001.002-.777 0-1.555.001-2.333Z"
    />
  </svg>
);

export default IcFunctionVIP;
